import { render, staticRenderFns } from "./media-upload-drawer.vue?vue&type=template&id=7a2048f0&"
import script from "./media-upload-drawer.vue?vue&type=script&lang=js&"
export * from "./media-upload-drawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports